
    import {Component, Vue, Watch} from "vue-property-decorator";

    @Component({
        name: "InStock"
    })
    export default class extends Vue {

        private created(): void {
        }

        private mounted(): void {

        }

    }
